export default "__VITE_ASSET__6QUbbYA2__"